import { tlStore } from "../CorBase/CoreBase";

export function currentUserHasRight(requiredRight: string): boolean {
	return tlStore.state.userRight.indexOf(requiredRight) >= 0;
}

export function currentUserIsSuperUser(): boolean {
	return tlStore.state.isSuperUser;
}

export function currentUserHasModule(module: string): boolean {
	return tlStore.state.tenantModules.filter(c => c.identifier == module).length > 0;
}